<template>
  <a-layout
    :class="{
      settings__borderLess: settings.isBorderless,
      settings__squaredBorders: settings.isSquaredBorders,
      settings__fixedWidth: settings.isFixedWidth,
      settings__menuShadow: settings.isMenuShadow,
      settings__menuTop: settings.isMenuTop,
    }"
  >
    <!-- left menu -->
    <a-layout-header>
      <cui-topbar />
    </a-layout-header>
    <a-layout>
      <a-layout-content>
        <div class="utils__content">
          <section class="card">
            <div class="card-body" :class="$style.divText">
              <h1><strong>Welcome to Cost Segregation</strong></h1>
              <h4>
                <p>
                  <strong
                    >You are not authorized to access the application.</strong
                  >
                </p>
              </h4>
              <h4>
                <p><strong>Please contact your Administrator.</strong></p>
              </h4>
            </div>
          </section>
        </div>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<style lang="scss" module>
@import "./style.module.scss";
</style>

<script>
import { mapState } from 'vuex'
import CuiTopbar from '@/components/LayoutComponents/Topbar'

export default {
  name: 'UnauthorizedUser',
  computed: mapState(['settings']),
  components: { CuiTopbar },
  data: function () {
    return {}
  },
  mounted() {
    const accessToken = JSON.parse(localStorage.getItem('okta-token-storage'))
    if (accessToken && accessToken.accessToken) {
      this.$router.push('/dashboard')
    }
  },
}
</script>
